import type { Producto } from '@compranorte/domain'
import { iconoCategoria } from './icons'

/**
 * Sustituto de fotografía. El catálogo no puede depender de imágenes externas
 * (no hay red garantizada en una faena ni en una sala de reunión), y la mayoría
 * de los proveedores no tiene una foto decente de un filtro hidráulico. Así que
 * cuando no hay imagen el producto muestra una ficha técnica visual —icono de
 * categoría, marca y SKU sobre una trama diagonal a 45°— que se lee como una
 * ficha deliberada y no como una foto que faltó cargar. Con `imagenUrl` se usa
 * la foto real.
 */
/** Lo mínimo para dibujar la ficha: no exige el producto completo. */
type Ficha = Pick<Producto, 'nombre' | 'sku' | 'marca' | 'categoriaId'> & {
  imagenUrl?: string
}

export function ProductoTile({ producto, alto = 'h-28' }: { producto: Ficha; alto?: string }) {
  const Icono = iconoCategoria(producto.categoriaId)
  if (producto.imagenUrl) {
    return (
      <img
        src={producto.imagenUrl}
        alt={producto.nombre}
        loading="lazy"
        decoding="async"
        width={320}
        height={224}
        className={`w-full ${alto} object-cover bg-acero-100`}
      />
    )
  }
  return (
    <div
      className={`relative w-full ${alto} bg-acero-50 border-b border-acero-200 grid place-items-center overflow-hidden`}
      aria-hidden="true"
    >
      <div
        className="absolute inset-0 opacity-[0.5]"
        style={{
          backgroundImage:
            'repeating-linear-gradient(45deg, var(--color-acero-200) 0 1px, transparent 1px 9px)',
        }}
      />
      <Icono size={30} className="relative text-acero-400" />
      <span className="absolute bottom-1 right-1.5 num text-[9.5px] text-acero-400 tracking-tight">
        {producto.sku}
      </span>
      <span className="absolute bottom-1 left-1.5 text-[9.5px] font-semibold uppercase tracking-[0.08em] text-acero-400">
        {producto.marca}
      </span>
    </div>
  )
}
